import { LitElement, html, css } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import { Image } from '../Image/Image';
import '../ReadMark/BlueReadMark/BlueReadMark';
import '../ReadMark/ClockMark/ClockMark';
import '../ReadMark/DoubleMark/DoubleMark';
import '../ReadMark/SingleMark/SingleMark';
import '../Time/Timestamp';
import '../MessageBubble/ImageMessageBubble/ImageMessageBubble';
import '../MessageBubble/VideoMessageBubble/VideoMessageBubble';
import '../MessageBubble/DocumentMessageBubble/DocumentMessageBubble';
import '../EmojiReactions/EmojiReactions.js';
import '../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';
import '../../../components/ChatUIComponent/ReactionContainer.js';
class ReplyMessageContainer extends LitElement {
  static properties = {
    color: { type: String },
    fontSize: { type: String },
    textAlign: { type: String },
    fontWeight: { type: String },
    fontStyle: { type: String },
    backgroundColor: { type: String },
    borderColor: { type: String },
    borderWidth: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    fontFamily: { type: String },
    width: { type: String },
    height: { type: String },
    display: { type: String },
    alignItems: { type: String },
    justifyContent: { type: String },
    padding: { type: String },
    messageBody: { type: String },
    parentMessageBody: { type: String },
    senderName: { type: String },
    messageTime: { type: String },
    icon1: { type: Object },
    repliedMessage: { type: String },
    isRead: { type: Boolean },
    isDelivered: { type: String },
    messageInfo: { type: Object },
    userMetaData: { type: Object },
    parentMessageTime: { type: String },
    parentMessageMediaUrl: { type: String },
    parentMessageType: { type: String },
    parentMessageId: { type: String },
    parentMessageSenderIdentifier: { type: String },
    parentMessageSenderName: { type: String },
    isSelf: { type: Boolean },
    onMediaClick: { type: Function },
    allAttachments: { type: Array },
    showEmojiReactions: { type: Boolean },
    reactions: { type: Object },
    messageId: { type: String },
    timeColor: { type: String },
    showReactionButton: { type: Boolean },
    showEmojiReactions: { type: Boolean },
    showConfirmationPopup: { type: Boolean },
    selectedEmojiToRemove: { type: Object },
    showAllReactionsPopup: {type: Boolean},
    showReactionOnHover: {type: Boolean}
  };

  static styles = css`
    .reply-block-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      overflow-wrap: break-word;
      border-radius: 7px;
      position: relative;
    }
    .icon-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: flex-start;
      width: 100%;
    }

    .icon-container .sender-info {
      font-size: 14px;
    }

    .icon-container div {
      cursor: pointer;
    }

    .icon-container svg {
      cursor: pointer;
    }

    .reply-body {
      background-color: var(--reply-body-color);
      display: flex;
      flex-direction: column;
      align-content: flex-start;
      align-items: flex-start;
      padding: 10px;
      border-radius: 10px;
      cursor: pointer;
      width: -webkit-fill-available;
      overflow: hidden;
      overflow-wrap: anywhere;
      text-align: left;
    }

    .outgoing-reply-body {
      background-color: var(--bg-primary-color);
    }

    .incoming-reply-body {
      background-color: var( --bg-primary-light);
    }

    .replied-message-section {
      display: flex;
      gap: 4px;
      flex-direction: column;
      width: 100%;
      overflow: hidden;
      overflow-wrap: anywhere;
      text-align: left;
    }

    .message-footer {
      display: flex;
      gap: 4px;
      margin-left: auto;
    }

    .message-body-container {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    emoji-reactions {
      position: absolute;
      top: 15px;
      z-index: 99;
    }


     .reactions-display {
      position: absolute;
      bottom: -10px;
      right: 10px;
      display:grid;
       grid-template-columns: repeat(3, auto);
       gap: 0;
       margin-top: 4px;
       background-color: transparent;
    }
    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      cursor: pointer;
      font-size: 20px;
      background: var(--bg-secondary-color);
    }

    .reaction-button {
      position: absolute;

      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }


    .reaction-list-item {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;
      padding: 4px;
    }

    .reaction-list-item:hover {
      background: var(--bg-secondary-color);
      border-radius: 4px;
    }

    .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }
         reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }
      .replycontainer{
      display:flex;
      align-items: center;
      }
      .replycontainer span{
            font-size: 12px;
            }
  `;

  constructor() {
    super();
    this.color = 'black';
    this.fontSize = '16px';
    this.textAlign = 'center';
    this.fontWeight = 'normal';
    this.fontStyle = 'normal';
    this.backgroundColor = 'transparent';
    this.borderColor = 'transparent';
    this.borderWidth = '';
    this.borderStyle = '';
    this.borderRadius = '4px';
    this.fontFamily = '';
    this.width = '';
    this.height = 'auto';
    this.padding = '10px';
    this.messageBody = '';
    this.parentMessageBody = ''; // Added initialization
    this.senderName = '';
    this.messageTime = '';
    this.parentMessageTime = '';
    this.icon1 = null;
    this.messageInfo = {};
    this.userMetaData = {};
    this.allAttachments = []; // Added initialization
    this.onMediaClick = () => {}; // Added initialization
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
    this.showAllReactionsPopup = false;
    this.showReactionButton = false;
    this.showReactionOnHover = true;
  }

  renderMedia() {
    let messageContent;

    if (this.messageInfo?.attachments?.length > 0) {
      const attachment = this.messageInfo.attachments[0];
      const mimeType = attachment.mimeType;

      if (mimeType.startsWith('image/')) {
        messageContent = html`
          <image-message
            .isSelf=${this.isSelf}
            borderRadius="6px 6px 0 6px"
            .time=${this.messageInfo.sentAt}
            .imageSrc=${attachment.mediaUrl}
            height="220px"
            width="250px"
            .isRead=${this.messageInfo.readByAll}
            borderWidth="5px"
            borderColor="var(--bg-grey-color)"
            borderStyle="solid"
            .isDelivered=${this.isDelivered}
            .allAttachments=${this.allAttachments}
            .textColor=${this.isSelf ? 'var(--text-outgoing-message)' : 'var(--text-incoming-message)'}
            .onImageClick=${this.onMediaClick}
            .message=${this.messageInfo.body}
          ></image-message>
        `;
      } else if (mimeType.startsWith('video/')) {
        messageContent = html`
          <video-message
            height="220px"
            width="250px"
            padding="0px 0px 30px 0px"
            .isSelf=${this.isSelf}
            borderRadius="6px 6px 0 6px"
            .time=${this.messageInfo.sentAt}
            .type=${attachment.mimeType}
            .videoSrc=${attachment.mediaUrl}
            .isRead=${this.messageInfo.readByAll}
            .isDelivered=${this.messageInfo.deliveredToAll}
            .textColor=${this.isSelf ? 'var(--text-outgoing-message)' : 'var(--text-incoming-message)'}
            .message=${this.messageInfo.body}
          ></video-message>
        `;
      } else if (mimeType.startsWith('application/')) {
        messageContent = html`
          <document-message
            .docType=${attachment.mimeType}
            .fileName=${attachment.name}
            .href=${attachment.mediaUrl}
            width="220px"
            borderRadius="6px 6px 0 6px"
            .time=${this.messageInfo.sentAt}
            .docName=${attachment.name}
            .isRead=${this.messageInfo.readByAll}
            .isSelf=${this.isSelf}
            .textColor=${this.isSelf ? 'var(--text-outgoing-message)' : 'var(--text-incoming-message)'}
            .isDelivered=${this.messageInfo.deliveredToAll}
            .message=${this.messageInfo.body}
          ></document-message>
        `;
      }
    }

    // If no attachments or unhandled mime type, render text message
    if (!messageContent) {
      messageContent = html`
        ${this.messageInfo.body}
        <div class="message-footer" style="font-size:${parseInt(this.fontSize) - 4}px ">
                    <timestamp-element .time="${this.messageTime}" .color="${this.timeColor}"></timestamp-element>
          ${this.isSelf
            ? this.isRead == true
              ? html`<blue-read-mark></blue-read-mark>`
              : this.isDelivered == 'true'
                ? html`<double-mark></double-mark>`
                : this.isDelivered == 'pending'
                  ? html`<clock-mark></clock-mark>`
                  : html`<single-mark></single-mark>`
            : null}
        </div>
      `;
    }

    return messageContent;
  }

  handleMouseEnter() {
    if(this.showReactionOnHover) {
    this.showReactionButton = true;
    }
  }

  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;
      
      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

  handleOutsideClick = (e) => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');
    
    const path = e.composedPath();
    
    if ((this.showEmojiReactions &&
      !path.includes(emojiReactions) &&
      !path.includes(messageContainer)) ||
      (this.showConfirmationPopup &&
      !path.includes(reactionContainer) &&
      !path.includes(messageContainer))
    ) {
      this.showEmojiReactions = false;
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
  toggleEmojiReactions() {
    this.showConfirmationPopup = false;

    this.showEmojiReactions = !this.showEmojiReactions;
    
    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }
  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleReactionRemove(reaction) {
    this.showEmojiReactions = false;

    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }

  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }


  render() {
    let parentMessageContent = this.parentMessageBody;

    if (this.parentMessageMediaUrl && this.parentMessageType) {
      if (this.parentMessageType.startsWith('image/')) {
        parentMessageContent = html`
                <div class='replycontainer' >
        <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M216-144q-29.7 0-50.85-21.5Q144-187 144-216v-528q0-29 21.15-50.5T216-816h528q29.7 0 50.85 21.5Q816-773 816-744v528q0 29-21.15 50.5T744-144H216Zm84-144h360.19Q671-288 676-298t-2-19L566-461q-5.25-8-14-8t-14 8l-94 125-58-77q-5.25-8-14-8t-14 8l-71.82 96.03Q279-308 284.25-298q5.25 10 15.75 10Z"/></svg>
                <span>Photo</span>
        `;
      } else if (this.parentMessageType.startsWith('video/')) {
        parentMessageContent = html`
        <div class='replycontainer' >
         <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M216-192q-29 0-50.5-21.5T144-264v-432q0-29.7 21.5-50.85Q187-768 216-768h432q29.7 0 50.85 21.15Q720-725.7 720-696v168l113-113q8-8 19.5-3.83Q864-640.67 864-629v297.88Q864-319 852.5-315q-11.5 4-19.5-4L720-432v168q0 29-21.15 50.5T648-192H216Z"/></svg>
        <span>Video</span>
         </div>
         `;
      } else if (this.parentMessageType.startsWith('application/')) {
        parentMessageContent = html`
        <div class='replycontainer' >
<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M336-240h288v-72H336v72Zm0-144h288v-72H336v72ZM263.72-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72ZM528-624h168L528-792v168Z"/></svg>        <span>Document</span>
         </div>
         `;
      }else if (this.parentMessageType.startsWith('audio/')) {
        parentMessageContent = html`
        <div class='replycontainer' >
<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="30px" fill="#000000"><path d="M285-240v-480h60v480h-60ZM450-80v-800h60v800h-60ZM120-400v-160h60v160h-60Zm495 160v-480h60v480h-60Zm165-160v-160h60v160h-60Z"/></svg>         </div>
         `;
      }
    }
    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0); 
    
    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;
    return html`
      <div
        class="reply-block-container"
        @emoji-selected="${this.handleEmojiSelect}"
        @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}"
        style=${styleMap({
          color: this.color,
          fontSize: this.fontSize,
          textAlign: this.textAlign,
          fontWeight: this.fontWeight,
          fontStyle: this.fontStyle,
          backgroundColor: this.backgroundColor,
          borderColor: this.borderColor,
          borderWidth: this.borderWidth,
          borderStyle: this.borderStyle,
          borderRadius: this.borderRadius,
          fontFamily: this.fontFamily,
          width: this.width,
          height: this.height,
          alignItems: this.alignItems,
          justifyContent: this.justifyContent,
          display: this.display,
          padding: this.padding,
        })}
      >
        ${this.showReactionButton
          ? html`
              <div
                class="reaction-button"
                style=" left:${this.isSelf ? '-25px' : null};
     right:${this.isSelf ? null : '-25px'}; "
                @click="${() => this.toggleEmojiReactions()}"
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
                  <path
                    d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"
                  />
                </svg>
              </div>
            `
          : ''}
        <div class="reply-body ${this.isSelf ? 'outgoing-reply-body' : 'incoming-reply-body'}" @click=${this.handleReplyBodyClick}>
          <div class="icon-container">
            ${this.icon1
              ? html`<div>${Image({ src: this.icon1, alt: 'icon' })}</div>`
              : html`
                  <svg width="${parseInt(this.fontSize) + 10}px" height="${this.fontSize}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M4.5 12L9.5 7M4.5 12L9.5 17M4.5 12L14.5 12C16.1667 12 19.5 13 19.5 17"
                        stroke=${this.color}
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                  </svg>
                `}
            <div style="font-size: 14px" class="message-body-container">${parentMessageContent}</div>
          </div>
          <span style="font-size: 12px" class="sender-info">
            ${this.parentMessageSenderIdentifier === this.userMetaData?.userIdentifier ? 'you' : this.parentMessageSenderName}
          </span>
        </div>
        <div class="replied-message-section" style="font-size: ${this.fontSize}">${this.renderMedia()}</div>
        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
          ${remainingCount > 0
            ? html`
                <span @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count" > +${remainingCount} </span>
             
              `
            : ''}
        </div>

       ${this.showConfirmationPopup
          ? html`
             <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container>
            `
          : ''}

        <div class="emoji-slider">
          ${this.showEmojiReactions
            ? html`
                <emoji-reactions
                  .isOpen="${this.showEmojiReactions}"
                  .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}"
                  .selectedEmojis="${this.reactions}"
                ></emoji-reactions>
              `
            : ''}
        </div>
      </div>
    `;
  }

  handleReplyBodyClick() {
    const event = new CustomEvent('find-and-scroll-to-message', {
      detail: { messageId: this.parentMessageId,
        isReplyClick: true
       },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }

}

customElements.define('reply-message-container', ReplyMessageContainer);
